module.exports = __webpack_public_path__ + "static/media/close-icon.17d4e4d1.svg";